import React from 'react'

import Media from '../Media'

export default function Recording(props) {
  /* eslint-disable react/jsx-props-no-spreading */
  return <Media {...props} />
  /* eslint-enable react/jsx-props-no-spreading */
}
